<template>
  <div class="page-content">
    <page-template
      ref="tableOptionsRef"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';

  import api from '@/config/api';
  import userPower from '@/mixin/userPower';
  import date from '@/mixin/date';

  export default {
    mixins: [userPower, date],
    components: {
      pageTemplate
    },
    data() {
      let stCreateDttm = this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
      let edCreateDttm = this.$moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
      return {
        searchOptions: {
          simple: [
            {label: '', prop: 'orderNo', type: 'input', ifFuzzy: true, placeholder: '请输入业务单号'}
          ],
          complex: [
            {label: '选择日期', prop: 'CreateDttm', type: 'dateTimeRangeButton', dateType: 'datetime', span: 24},
            // {
            //   label: "调价级别",
            //   type: "select",
            //   prop: "relateType",
            //   data: this.$utils.getCacheStatus('asPriceAdjustmentOrder.relateType'),
            //   change: this.getSelectParam,
            //   span: 12,
            // },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              isHasAll: true,
              data: [],
              url: api.system.seStore,
              span: 6
            },
            // {
            //   label: "货号",
            //   type: "input",
            //   prop: "otherName",
            //   isFuzzy: true,
            //   span: 12,
            // },
            // {
            //   label: "调价单号",
            //   type: "input",
            //   prop: "orderNo",
            //   span: 6,
            // },
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              defaultValue: 20,
              type: 'select',
              data: [{label: '未审核', value: 20}, {label: '已审核', value: 10}],
              span: 12
            }
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addGoods
          },
          {
            label: '刷新',
            code: 'refresh'
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.reviewerStatus != 10;
            }
          },
          {
            label: '审核',
            code: 'audit',
            filter: (data) => {
              return false // 去掉列表页审核按钮
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.reviewerStatus != 10;
            }
          }
        ],
        // 表格信息配置
        tableOptions: {
          indexShow: true, // 是否显示索引
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '180',
              align: 'center',
              showDetail: true
            },
            {
              label: '调价门店',
              prop: 'storeName',
              width: '80',
              align: 'center'
            },
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              width: '80',
              align: 'center',
              enumData: this.$utils.getCacheStatus('asPriceAdjustmentOrder.reviewerStatus')
            },
            {label: '制单人', prop: 'voucherName', width: '80', align: 'center'},
            {label: '制单时间', prop: 'voucherDttm', width: '125', align: 'center'},
            {label: '审核人', prop: 'reviewerName', width: '80', align: 'center'},
            {label: '审核时间', prop: 'reviewerDttm', width: '125', align: 'center'},
            {label: '备注', prop: 'remarks', width: '80', align: 'center'}
          ],
          param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()}
          // url: api.archives.priceDadjap
        },
        // 详情
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '100px',
            top: '0'
          },
          span: 8,
          labelWidth: '130',
          columns: [
            // {
            //   label: '调价级别',
            //   prop: 'relateType',
            //   enumData: this.$utils.getCacheStatus('asPriceAdjustmentOrder.relateType'),
            //   span: 12,
            // },

            {
              label: '业务单号',
              prop: 'orderNo',
              span: 12
            },
            {
              label: '调价门店',
              prop: 'storeName',
              span: 12
            },
            // {
            //   label: '门店',
            //   prop: 'storeId',
            //   url: api.system.seStore,
            //   span: 12,
            // },
            {
              label: '调价类别',
              prop: 'types',
              span: 12,
              enumData: this.$utils.getCacheStatus('asPriceAdjustmentOrder.type')
            }, {
              label: '备注',
              prop: 'remarks',
              span: 12
            }
          ],
          tablesProp: {
            adjustmentGoodsMapList: {
              url: api.archives.priceDadjapGoods + '/detail/page',
              tableName: 'adjustmentGoodsMapList',
              indexShow: true,
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '100'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  width: '100'
                },
                {
                  label: '规格',
                  prop: 'specs',
                  width: '100'
                },
                {
                  label: '单位',
                  prop: 'unitName',
                  width: '100'
                },
                {
                  label: '原进货价',
                  prop: 'buyPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '进货价',
                  type: 'inputNumber',
                  prop: 'paBuyPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '原零售价',
                  prop: 'retailPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '零售价',
                  type: 'inputNumber',
                  prop: 'paRetailPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '原最低零售价',
                  prop: 'lowestPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '最低零售价',
                  type: 'inputNumber',
                  prop: 'paLowestPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '原会员价',
                  prop: 'vipPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '会员价',
                  type: 'inputNumber',
                  prop: 'paVipPrice',
                  align: 'center',
                  width: '110'
                },
                // {
                //   label: '原PLUS会员价',
                //   prop: 'plusVipPrice',
                //   align: 'center',
                //   width: '110',
                // },
                // {
                //   label: 'PLUS会员价',
                //   type: 'inputNumber',
                //   prop: 'paPlusVipPrice',
                //   align: 'center',
                //   width: '110',
                // },
                {
                  label: '原批发价',
                  prop: 'tradePrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '批发价',
                  type: 'inputNumber',
                  prop: 'paTradePrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '原配送价',
                  prop: 'deliveryPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '配送价',
                  type: 'inputNumber',
                  prop: 'paDeliveryPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90'
                }
              ]
            }
          },
          // 打印的列表
          printTablesProp: {
            adjustmentGoodsMapList: {
              tableName: 'adjustmentGoodsMapList',
              showSummary: true,
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '100'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  width: '100'
                },
                {
                  label: '规格',
                  prop: 'specs',
                  width: '100'
                },
                {
                  label: '单位',
                  prop: 'unitName',
                  width: '100'
                },
                {
                  label: '原进货价',
                  prop: 'buyPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '进货价',
                  type: 'inputNumber',
                  prop: 'paBuyPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '原零售价',
                  prop: 'retailPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '零售价',
                  type: 'inputNumber',
                  prop: 'paRetailPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '原最低零售价',
                  prop: 'lowestPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '最低零售价',
                  type: 'inputNumber',
                  prop: 'paLowestPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '原会员价',
                  prop: 'vipPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '会员价',
                  type: 'inputNumber',
                  prop: 'paVipPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '原PLUS会员价',
                  prop: 'plusVipPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: 'PLUS会员价',
                  type: 'inputNumber',
                  prop: 'paPlusVipPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '原批发价',
                  prop: 'tradePrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '批发价',
                  type: 'inputNumber',
                  prop: 'paTradePrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '原配送价',
                  prop: 'deliveryPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '配送价',
                  type: 'inputNumber',
                  prop: 'paDeliveryPrice',
                  align: 'center',
                  width: '110'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90'
                }
              ]
            }
          },
          url: api.archives.priceDadjap
        }
      };
    },
    created() {
      this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, 10);
      this.setDadjapStoreId(this.searchOptions.complex);
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      this.$nextTick(() => {
        this.tableOptions.url = api.archives.priceDadjap
        this.$refs['tableOptionsRef'].operationSuccess();
      })
    },
    methods: {
      toEditPage(row) {
        this.$router.push({path: '/archives/price/dadjap/add?id=' + row.id});
      },
      addGoods() {
        this.$router.push({path: '/archives/price/dadjap/add'});
      },
      getSelectParam(form) {
        let storeId = this.searchOptions.complex.filter(item => item.prop === 'storeId')[0];
        if (form.relateType === 10) {
          storeId.hidden = true;
        } else {
          // 选择门店的时候，查询商户相应的门店
          storeId.hidden = false;
        }
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/archives/price/Dadjap.vue